// extracted by mini-css-extract-plugin
export default {"container":"CardsPay_container__YYWip","flex":"CardsPay_flex__AabjU","box":"CardsPay_box__SaAls","imge":"CardsPay_imge__dzotJ","check":"CardsPay_check__QiEHr"};